import camelGet from '@rover/react-lib/src/utils/camelGet';
import { ApiServiceLinksRetrieve200 } from '@rover/rsdk/src/apiClient/latest';

export const SERVICE_LINKS_URL = 'frontend/service-links/';

export const get = async (): Promise<ApiServiceLinksRetrieve200> => {
  return camelGet<ApiServiceLinksRetrieve200>({ url: SERVICE_LINKS_URL });
};
